// import { get } from 'lodash';
import { APIS } from '../../../../../lib/constants/apis';
import Schema from '../../../../../lib/paths/antrag_FULL_Paths.json';
// import { addIndexesToPath } from '../../../../../utils/helper';
const P = Schema.attributes;

type Dependencies = {
	files: any[];
	relations: any[];
};
function FoerderAntragDependencies(_application: any) {
	let dependencies: Dependencies = {
		files: [],
		relations: [],
	};
	dependencies.relations.push({ field: P.Antrag_Kostenpositions.path, api: APIS.Kostenposition }); 
	// dependencies.relations.push({ field: P.MKS.path, api: APIS.Organisation }); 

	return dependencies;
}
export { FoerderAntragDependencies };
